import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MeetingsService, PlatformService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import { Classroom, EContentOrder, Meeting, MeetingStatusEnum, Router as ContentRouter } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs';
import {ErrorNotificationService} from "@shared/error-notification/error-notification.service";

@Component({
  selector: 'app-user-service-meetings',
  templateUrl: './user-service-meetings.component.html',
  styleUrls: ['./user-service-meetings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserServiceMeetingsComponent extends ChangableComponent implements OnInit {
  @Input()
  public user_service_id: string;

  public meeting: Meeting;
  public limit = 1;
  public meetingCheckoutDialogOpened: boolean;

  public constructor(
    public errorNotificationService: ErrorNotificationService,
    protected meetingsService: MeetingsService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
    public deviceService: DeviceDetectorService,
  ) {
    super(cdr, platform);
  }

  ngOnInit(): void {
    this.loadMeetings();
  }

  private loadMeetings() {
    this.meetingsService
      .getMeetings(
        {
          user_service_id: this.user_service_id, // для текущей услуги
          upcoming: true, // те, в которых мне предстоит заниматься
          order: EContentOrder.date_asc, // сортировка по возрастанию дат
        },
        { page: 1, pageSize: 1 },
      )
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          this.meeting = res.results.map((m) => new Meeting(m))[0];
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        }
      });
  }

  public classroomRoute(classroom: Classroom): string[] {
    return ContentRouter.classroomRoute(classroom);
  }

  public get isAcceptRequired() {
    return this.meeting.status === MeetingStatusEnum.accept_required;
  }

  public onPaymentSucceed() {
    this.meetingCheckoutDialogOpened = false;
    this.meeting.status = MeetingStatusEnum.accepted;
    this.detectChanges();
  }

  public formatDate(date) {
    return new Date(date);
  }
}
